import { useEffect, useState } from "react";
import { Row, Col, Typography, Card, Skeleton, Pagination } from "antd";
import { F3 } from "../../../../assets";
import CustomHeader2 from "../../../landingpage/Header/CustomHeader2";
import { Footers } from "../../../Footers";
import { useHttp } from "../../../../utils/DataHendler";
import { useNavigate } from "react-router-dom";
import { AppstoreOutlined, HomeOutlined } from "@ant-design/icons";

const { Title } = Typography;

const IntershipPage = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const { getData } = useHttp();
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 12,
    total: 0,
    totalPages: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchData = async (queryParams) => {
    setLoading(true);
    try {
      const response = await getData(
        `/job?job_category_id=1`,
        { params: queryParams },
        false
      );
      if (response.success) {
        const structuredData = response.data.data.map((item) => ({
          ...item,
          key: item.id,
        }));

        setData(structuredData);
        setPagination({
          page: response.data.pagination.page,
          limit: response.data.pagination.limit,
          total: response.data.pagination.total,
          totalPages: response.data.pagination.totalPages,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    fetchData({ ...filters, page: newPage, limit: pagination.limit });
  };

  useEffect(() => {
    fetchData({ page: pagination.page, limit: pagination.limit });
  }, []);

  return (
    <div>
      <CustomHeader2 />

      {/* Header with grayscale fade and breadcrumb */}
      <div style={{ position: "relative", height: "350px" }}>
        <div
          style={{
            backgroundImage: `url('${F3}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "grayscale(5%)",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 2,
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 3,
            padding: "15px 0 0 15px",
          }}
        >
          {/* <Breadcrumb style={{ color: "#fff" }}>
              <Breadcrumb.Item>
                <a
                  style={{ color: "#fff" }}
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  Home
                </a>
              </Breadcrumb.Item>
              <Breadcrumb.Item style={{ color: "#fff" }}>Career</Breadcrumb.Item>
            </Breadcrumb> */}
        </div>
        <div
          style={{
            position: "relative",
            zIndex: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <Title
            style={{
              color: "#fff",
              fontSize: "3rem",
              textShadow: "0 0 10px rgba(0,0,0,0.5)",
              margin: 0,
            }}
          >
            Career
          </Title>
        </div>
      </div>

      {/* Career List */}
      <div style={{ padding: "24px 48px" }}>
        <Row gutter={[24, 24]}>
          {loading
            ? Array.from({ length: pagination.limit }).map((_, idx) => (
                <Col xs={24} sm={12} md={8} lg={6} key={idx}>
                  <Card
                    cover={
                      <Skeleton.Image
                        active
                        style={{ width: "100%", height: 200 }}
                      />
                    }
                  >
                    <Skeleton
                      active
                      paragraph={{ rows: 2 }}
                      title={{ width: "80%" }}
                    />
                  </Card>
                </Col>
              ))
            : data.length > 0
            ? data.map((job) => (
                <Col xs={24} sm={12} md={8} lg={6} key={job.id}>
                  <Card
                    hoverable
                    onClick={() => {
                      navigate(`/career/${job.id}`);
                    }}
                    cover={
                      <img
                        alt={job.title}
                        src={
                          job.image_url || "https://via.placeholder.com/300x200"
                        }
                        style={{ height: 200, objectFit: "cover" }}
                      />
                    }
                  >
                    <div
                      style={{ fontSize: 12, color: "#888", marginBottom: 4 }}
                    >
                      {job.created_at}
                    </div>
                    <Title level={5} style={{ marginBottom: 4 }}>
                      {job.title}
                    </Title>
                  </Card>
                </Col>
              ))
            : !loading && (
                <Col
                  span={24}
                  style={{ textAlign: "center", padding: "40px 0" }}
                >
                  <Title level={4}>Belum ada career</Title>
                </Col>
              )}
        </Row>

        {/* Pagination */}
        {!loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 40,
              paddingRight: "5vw",
              marginBottom: 64,
            }}
          >
            <Pagination
              current={pagination.page}
              total={pagination.total}
              pageSize={pagination.limit}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        )}
      </div>

      <Footers />
    </div>
  );
};

export default IntershipPage;
